import { render } from "./accountDeletionSuccess.vue?vue&type=template&id=5d510de7&scoped=true"
import script from "./accountDeletionSuccess.vue?vue&type=script&lang=js"
export * from "./accountDeletionSuccess.vue?vue&type=script&lang=js"

import "./accountDeletionSuccess.vue?vue&type=style&index=0&id=5d510de7&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5d510de7"]])

export default __exports__